import React from "react";

import { bind } from "bind-decorator";

import { Main } from "./Main";
import { Navbar } from "./components/Navbar";
import { BitmakerAPIClient } from "./services/BitmakerApp";
import { CurrentUser, CurrentUserFromJSON } from "./bitmaker";

interface Props { }

interface State {
    user?: CurrentUser;
}

class App extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            user: undefined,
        };
    }

    public componentDidMount() {
        const retrievedUserJSON = window.localStorage.getItem("bmCurrentUser");
        const tokenExpiry = window.localStorage.getItem("tokenExpiration");
        const currentTime = Date.now();

        if (retrievedUserJSON && tokenExpiry) {
            try {
                const user = CurrentUserFromJSON(JSON.parse(retrievedUserJSON));

                if (parseInt(tokenExpiry) < currentTime) {
                    this.refreshAccessToken();
                } else {
                    this.setState({
                        user: user,
                    });
                }
            } catch (e) {
                this.handleLogout();
            }
        } else {
            this.handleLogout();
        }
    }

    @bind private refreshAccessToken() {
        BitmakerAPIClient.refreshAccessToken((expires_in: number | null) => {
            if (expires_in) {
                this.handleLogin(expires_in);
            } else {
                console.error("Failed to refresh access token");
                this.handleLogout();
            }
        });
    }

    @bind update_state(userObj: CurrentUser) {
        this.setState({
            user: userObj,
        });
    }

    @bind private handleLogin(expiresIn: number) {
        const currentTime = Date.now();
        const tokenExpirationTime = currentTime + expiresIn * 1000;

        BitmakerAPIClient.getUserDetails((user: CurrentUser | null) => {
            if (user) {
                this.update_state(user);

                window.localStorage.setItem(
                    "tokenExpiration",
                    tokenExpirationTime.toString(),
                );
            } else {
                this.handleLogout();
            }
        }, tokenExpirationTime);
    }

    @bind private handleLogout() {
        this.setState({ user: undefined });
        BitmakerAPIClient.removeUser();
    }

    public render() {
        return (
            <div className="App">
                <Navbar
                    loginSuccess={this.handleLogin}
                    logoutSuccess={this.handleLogout}
                    user={this.state.user}
                />
                <Main key={"main"} />
            </div>
        );
    }
}

export default App;
